import React from "react";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { Button } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";

export type CopyProps = {

  /**
   * A text to be copied
   */
  text: string | null;

  /**
   * Button size (medium by default)
   */
  size?: "small" | "medium";

  /**
   * With text
   */
  withLabel?: boolean;

  className?: string;
}

export const CopyButton: React.FC<CopyProps> = ({
  text,
  size = "small",
  withLabel = false,
  className,
}: CopyProps) => {
  if (!text) return null;

  const [spinner, useSpinner] = React.useState(false);
  const [copied, setCopied] = React.useState(false);
  const iconSize = size === "small" ? "small" : "medium";

  React.useEffect(() => {
    if (spinner) {
      setTimeout(() => {
        useSpinner(false);
        setCopied(true);
      }, 500);
    }
  }, [spinner]);

  const handleClick = () => {
    if (text) {
      useSpinner(true);
      navigator.clipboard.writeText(text);
    }
  };

  if (withLabel) {
    return (
      <Button
        variant="outlined"
        size={size}
        onClick={handleClick}
        className={className}
        startIcon={spinner ? <CircularProgress size={20} /> : <FileCopyIcon fontSize={iconSize} />}>
        {copied ? "Copied!" : "Copy"}
      </Button>
    );
  }

  return (
    <IconButton size={size} onClick={handleClick}>
      {spinner ? <CircularProgress size={20} /> : <FileCopyIcon fontSize={iconSize} />}
    </IconButton>
  );
};
